import { z } from 'zod';

// ─── Tenant Type ────────────────────────────────────────────────────
// Canonical Zod enum mirroring the Prisma TenantType enum.
// All consumers (event payloads, permission schemas) import from here.

export const TenantTypeEnum = z.enum(['API', 'ORGANIZATION', 'SUPER_TENANT']);
export type TenantType = z.infer<typeof TenantTypeEnum>;
